import { AllUsers, Avatar, Clickable, Col, Icon, Row, Spinner2, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { calculateCost } from '../../../lib';

const BoldText = styled.span`
  font-weight: 800;
  color: #000;
`;

const UserItem = ({
  user,
  handleSelect,
  handleRemove,
  detailsSelected,
  pricing,
  handleExclude,
  isPreselected
}) => {
  const [loading, setLoading] = useState(false),
    [modalVisible, setModalVisible] = useState(false),
    [showDetails, setShowDetails] = useState(true),
    { currency } = useSelector((state) => state.user.billing),
    { t } = useTranslation(),
    navigate = useNavigate(),
    totalCost =
      pricing &&
      pricing !== true &&
      calculateCost(pricing, currency, user.type === 'team' ? 'bundle' : 'single', 'monthly');

  async function handleClick(user, type) {
    setLoading(true);
    await handleSelect(user, type);
    setLoading(false);
  }

  if (!user) return null;

  return (
    <Col noFlex wid="100%">
      <Row between center>
        <Row center>
          <Clickable onClick={() => navigate(`/profile/${user.username}`)}>
            <Avatar user={user} />
          </Clickable>

          <Col marg="0 0 0 12px" gap="2px" noFlex center>
            <Text bold>{user.name}</Text>
            {pricing && pricing !== true && user.type !== 'team' ? (
              <Trans
                parent={({ children }) => (
                  <Text b2 wid="100%" maxWid="200px" col={theme.GREY_60}>
                    {children}
                  </Text>
                )}
                components={{
                  strong: <BoldText />
                }}
              >
                {t('subscribe.subscribeFor', {
                  amount: (totalCost / 100).toLocaleString(undefined, {
                    style: 'currency',
                    currency: currency || 'usd'
                  })
                })}
              </Trans>
            ) : (
              !!user?.bio?.length && (
                <Text b2 wid="100%" maxWid="200px" col={theme.GREY_60} numberOfLines={1}>
                  {user.bio}
                </Text>
              )
            )}
          </Col>
        </Row>

        {loading ? (
          <Row marg="0 16px 0 0">
            <Spinner2 />
          </Row>
        ) : (
          (!isPreselected || user.type !== 'team') && (
            <Row centerAll>
              <Clickable onClick={() => handleClick(user, 'single')}>
                <Row
                  wid={pricing ? '40px' : '36px'}
                  ht={pricing ? '40px' : '36px'}
                  hasBorder={!pricing && '2px solid #000'}
                  centerAll
                  hasRadius="40px"
                  bg={pricing ? theme.SECONDARY : 'transparent'}
                >
                  <Icon type="doubleCheck" dimensions={23} col={pricing ? '#fff' : '#000'} />
                </Row>
              </Clickable>

              <Clickable onClick={() => handleRemove(user)}>
                <Icon type="close" dimensions={14} col={theme.GREY_60} marg="0 5px 0 13px" />
              </Clickable>
            </Row>
          )
        )}
      </Row>

      {!!pricing && user.type === 'team' && (
        <Row noFlex marg="0 0 12px" between>
          <Row noFlex>
            <Col marg="0 0 0 4px" noFlex ht="64px" wid="64px">
              <Col noFlex ht="68px" wid="1px" bg={theme.GREY_20} marg="-16px 0 0" center />
            </Col>

            <Col marg="0 0 0 16px" center noFlex>
              <Text bold wid="100%" maxWid="200px">
                {t('subscribe.teamFan', { team: user?.name })}
              </Text>

              {detailsSelected ? (
                !!pricing.user.athletes?.length && (
                  <Clickable onClick={() => setModalVisible(true)} wid="100%">
                    <Text bold b2 wid="100%" maxWid="200px" col={theme.GREY_60}>
                      {t('subscribe.seeAllAthletes', {
                        number: pricing.user.athletes?.length || 0
                      })}
                    </Text>
                  </Clickable>
                )
              ) : (
                <Row wid="200px">
                  <Trans
                    parent={({ children }) => (
                      <Text b2 col={theme.GREY_60}>
                        {children}
                      </Text>
                    )}
                    components={{
                      strong: <BoldText />
                    }}
                  >
                    {t('subscribe.subscribeForTeam', {
                      amount: (totalCost / 100).toLocaleString(undefined, {
                        style: 'currency',
                        currency: currency || 'usd'
                      })
                    })}
                  </Trans>
                </Row>
              )}
            </Col>
          </Row>

          {!loading && (
            <Row noFlex center>
              <Clickable onClick={() => handleClick(user, 'bundle')}>
                <Row
                  pad={`${detailsSelected ? 8 : 6}px`}
                  hasBorder={!detailsSelected && '2px solid #000'}
                  bg={!!detailsSelected && theme.SECONDARY}
                  hasRadius="32px"
                  noFlex
                >
                  <Icon
                    type="doubleCheck"
                    dimensions={24}
                    col={!!detailsSelected ? '#fff' : '#000'}
                  />
                </Row>
              </Clickable>

              <Clickable marg="0 5px 0 13px" onClick={() => setShowDetails(false)}>
                <Icon type="close" dimensions={14} col={theme.GREY_60} />
              </Clickable>
            </Row>
          )}

          {user.type === 'team' ? (
            <AllUsers
              visible={modalVisible}
              closeModal={() => setModalVisible(false)}
              team={user}
            />
          ) : (
            <Row></Row>
          )}
        </Row>
      )}
    </Col>
  );
};

export default UserItem;
